import React, { useState } from "react";
import "../../style/pages/categoriespage/collection.css";
import { useNavigate } from "react-router-dom";
import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

import Header from "../../component/Header.jsx";

import co1 from "../../media3/categories/co1.png";
import co2 from "../../media3/categories/co2.png";
import co3 from "../../media3/categories/co3.png";
import co4 from "../../media3/categories/co4.png";
import co5 from "../../media3/categories/co5.png";
import co6 from "../../media3/categories/co6.png";
import co7 from "../../media3/categories/co7.png";
import co8 from "../../media3/categories/co8.png";
import co9 from "../../media3/categories/co9.png";
import co10 from "../../media3/categories/co10.png";
import co11 from "../../media3/categories/co11.png";
import co12 from "../../media3/categories/co12.png";
import co13 from "../../media3/categories/co13.png";
import co14 from "../../media3/categories/co14.png";
import co15 from "../../media3/categories/co15.png";
import co16 from "../../media3/categories/co16.png";
import co17 from "../../media3/categories/co17.png";
import co18 from "../../media3/categories/co18.png";
import co19 from "../../media3/categories/co19.png";
import co20 from "../../media3/categories/co20.png";
import co21 from "../../media3/categories/co21.png";
import co22 from "../../media3/categories/co22.png";
import co23 from "../../media3/categories/co23.png";
import co24 from "../../media3/categories/co24.png";
import co from "../../media3/categories/co.png";

// Dummy data
export const collectionsData = [
  { id: 1, name: "Dust II Collection | Slalom", img: co1, price: 61, maxPrice: 122, color: "red", rating: 4, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Dust II Collection featuring red Slalom ski-themed skins, bringing alpine agility to the iconic desert map." },
  { id: 2, name: "Mirage Collection | Blaze", img: co2, price: 80, maxPrice: 150, color: "orange", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Mirage Collection engulfed in fiery orange Blaze flames, igniting the dunes with elite covert weapon finishes." },
  { id: 3, name: "Inferno Collection | Fade", img: co3, price: 95, maxPrice: 160, color: "red", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Inferno Collection with smooth red-to-purple Fade gradient, blending heat and style in the burning streets." },
  { id: 4, name: "Nuke Collection | Orion", img: co4, price: 120, maxPrice: 180, color: "orange", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Nuke Collection under cosmic orange Orion stars, powering high-radiation combat with stellar covert skins." },
  { id: 5, name: "Vertigo Collection | See Ya Later", img: co5, price: 70, maxPrice: 125, color: "white", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Vertigo Collection with bold white 'See Ya Later' gator, waving off enemies from skyscraper heights." },
  { id: 6, name: "Train Collection | Hyper Beast", img: co6, price: 90, maxPrice: 140, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Train Collection roaring with yellow Hyper Beast monster, derailing foes with primal, high-capacity power." },
  { id: 7, name: "Overpass Collection | Fuel Injector", img: co7, price: 110, maxPrice: 160, color: "green", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Overpass Collection with industrial green Fuel Injector mechanics, overcharging urban warfare performance." },
  { id: 8, name: "Cache Collection | Melondrama", img: co8, price: 60, maxPrice: 120, color: "black", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Cache Collection in juicy black Melondrama watermelon slices, refreshing Mediterranean ruins with fruity flair." },
  { id: 9, name: "Cobblestone Collection | Llama Cannon", img: co9, price: 75, maxPrice: 130, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Cobblestone Collection with explosive orange Llama Cannon, blasting medieval castle walls with quirky chaos." },
  { id: 10, name: "Ancient Collection | Kill Confirmed", img: co10, price: 145, maxPrice: 200, color: "black", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Ancient Collection marked by black Kill Confirmed blood—proof of silent, lethal dominance in historic ruins." },
  { id: 11, name: "Anubis Collection | Bullet Queen", img: co11, price: 88, maxPrice: 150, color: "green", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Anubis Collection crowned with golden green Bullet Queen, ruling Egyptian sands with royal authority." },
  { id: 12, name: "Italy Collection | Handgun h9", img: co12, price: 55, maxPrice: 110, color: "blue", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Italy Collection with compact blue Handgun motifs, channeling mafia-style precision in narrow alleys." },
  { id: 13, name: "Assault Collection | h8 Avalanche", img: co13, price: 68, maxPrice: 125, color: "red", rating: 4, rarity: "Restricted", orderedBy: "Newest", currency: "USD", description: "Assault Collection in red Avalanche snowstorm camo, charging through urban winter ops with frosty aggression." },
  { id: 14, name: "Aztec Collection | k16 Xiangliu", img: co14, price: 92, maxPrice: 160, color: "black", rating: 4, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Aztec Collection coiled in black Xiangliu serpent scales, guarding jungle temples with mythical venom." },
  { id: 15, name: "Dust Collection |  k12 Muertos", img: co15, price: 63, maxPrice: 120, color: "black", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Dust Collection with black Muertos Day of the Dead skulls, honoring fallen warriors in sandy battlegrounds." },
  { id: 16, name: "Militia Collection | Angry Mob", img: co16, price: 85, maxPrice: 140, color: "black", rating: 5, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Militia Collection fueled by black Angry Mob graffiti, rallying guerrilla forces with rebellious fury." },
  { id: 17, name: "Office Collection | Cobra Strike", img: co17, price: 78, maxPrice: 130, color: "purple", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Office Collection with purple Cobra Strike venom, striking silently in corporate corridors." },
  { id: 18, name: "Safehouse Collection | Crazy 8", img: co18, price: 59, maxPrice: 110, color: "purple", rating: 2, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Safehouse Collection with chaotic purple Crazy 8 dice, gambling on luck in hidden strongholds." },
  { id: 19, name: "Bank Collection | Ticket to Hell", img: co19, price: 99, maxPrice: 160, color: "red", rating: 5, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Bank Collection burning with red Ticket to Hell flames, robbing vaults with infernal, high-value style." },
  { id: 20, name: "Lake Collection | Water Elemental", img: co20, price: 115, maxPrice: 175, color: "orange", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Lake Collection flowing with orange Water Elemental liquid energy, submerging enemies in mystical power." },
  { id: 21, name: "Baggage Collection | Asiimov", img: co21, price: 102, maxPrice: 155, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Baggage Collection in orange Asiimov future-tech geometry, scanning terminals with sci-fi precision." },
  { id: 22, name: "St. Marc Collection | Pole Position", img: co22, price: 66, maxPrice: 125, color: "orange", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "St. Marc Collection in orange Pole Position racing stripes, speeding through village lanes with track-ready flair." },
  { id: 23, name: "Canals Collection | boost Isaac", img: co23, price: 74, maxPrice: 130, color: "black", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Canals Collection with black Isaac holographic circuits, navigating Venetian waters with electrified tech." },
  { id: 24, name: "Havoc Collection | Boost Protocol", img: co24, price: 97, maxPrice: 160, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Havoc Collection upgraded with blue Boost Protocol cyber glow, overclocking chaos in elite covert operations." }
];

const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function Collection({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
    const [selectedRarity, setSelectedRarity] = useState(null);
  const [selectedOrderBy, setSelectedOrderBy] = useState(null);

  const navigate = useNavigate();

    let filteredCollections = collectionsData.filter((pistol) => {
    const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
    const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
    const inRating = !selectedRating || pistol.rating === selectedRating;
    const inRarity = !selectedRarity || selectedRarity === "Any" || pistol.rarity === selectedRarity;
    return inPrice && inColor && inRating && inRarity;
  });
  
  // Add sorting
  if (selectedOrderBy) {
    filteredCollections = [...filteredCollections].sort((a, b) => {
      switch (selectedOrderBy) {
        case "Price":
          return a.price - b.price;
        case "Rating":
          return b.rating - a.rating;
        case "Popularity":
          return a.id - b.id;
        case "Newest":
          return b.id - a.id;
        default:
          return 0;
      }
    });
  }
  
  const handleRarityChange = (rarity) => {
    setSelectedRarity(rarity === selectedRarity ? null : rarity);
  };
  
  const handleOrderByChange = (orderBy) => {
    setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
  };
  

  // Handlers
  const handlePriceChange = (e, idx) => {
    const newRange = [...priceRange];
    newRange[idx] = Number(e.target.value);
    setPriceRange(newRange);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };

    const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };


  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };

  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
    <div className="categories-page">
          <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
          <Filter
          openFilter={openFilter}
          toggleSection={toggleSection}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          selectedColors={selectedColors}
          handleColorChange={handleColorChange}
          selectedRating={selectedRating}
          handleRatingChange={handleRatingChange}
          colors={colors}
          ratings={ratings}
           selectedRarity={selectedRarity}
  handleRarityChange={handleRarityChange}
  selectedOrderBy={selectedOrderBy}
  handleOrderByChange={handleOrderByChange}
        />
        <ItemGrid
          items={filteredCollections}
          categoryImage={co}
          categoryAlt="CZ75-Auto"
          categoryTitle="CrazySti9 | Crazy8"
          categoryDescription="Explore the most iconic CS2 Collections, where every drop tells a story of design and legacy.
From classic weapon finishes to region-themed exclusives, each collection captures a unique era of Counter-Strike.
Build your perfect inventory by discovering rare skins tied to specific maps and updates.
"
          onItemClick={handleNavigate}
            isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
        />
      </div>
    </div>
  );
}

export default Collection;